import React from "react";
import { renderInline } from "./sr-chat-inline";

const isSep = (line: string) =>
    /^\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?\s*$/.test(line.trim());

const splitRow = (line: string) =>
    line
        .trim()
        .replace(/^\|/, "")
        .replace(/\|$/, "")
        .split("|")
        .map((c) => c.trim());

type Props = { lines: string[]; isUser?: boolean };

export const SrChatTable: React.FC<Props> = ({ lines, isUser }) => {
    const rows = lines.filter((l) => l.trim().startsWith("|") || l.includes("|"));
    if (rows.length < 2) return null;

    const header = splitRow(rows[0]);
    const bodyStart = isSep(rows[1]) ? 2 : 1;
    const body = rows.slice(bodyStart).map(splitRow);
    const thCls = isUser
        ? "border border-blue-300/60 bg-blue-600/35 px-2.5 py-1.5 text-left font-semibold"
        : "border border-slate-200 bg-slate-50 px-2.5 py-1.5 text-left font-semibold text-slate-700";
    const tdCls = isUser
        ? "border border-blue-300/50 px-2.5 py-1.5"
        : "border border-slate-200 px-2.5 py-1.5 text-slate-800";

    return (
        <div className="sr-chat-table my-2 overflow-x-auto rounded-xl border border-slate-200/80 shadow-sm">
            <table className="min-w-full border-collapse">
                <thead>
                    <tr>
                        {header.map((cell, i) => (
                            <th key={i} className={thCls}>
                                {renderInline(cell, `th-${i}`)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {body.map((row, ri) => (
                        <tr key={ri}>
                            {header.map((_, ci) => (
                                <td key={ci} className={tdCls}>
                                    {renderInline(row[ci] ?? "", `td-${ri}-${ci}`)}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
